import ReactDOM from 'react-dom'
import './monitoring/datadogInit'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import App from './App.tsx'

import './shared/i18n'
import { Notifications } from '@wpmedia/ads-notification'

let queryClient = new QueryClient()

ReactDOM.render(
	<QueryClientProvider client={queryClient}>
		<Notifications />
		<App />
		{process.env.NODE_ENV === 'development' && (
			<ReactQueryDevtools initialIsOpen={false} />
		)}
	</QueryClientProvider>,
	document.getElementById('root'),
)
